  <template lang="pug">
    v-card
        v-dialog(:fullscreen="isMobile" width="400" persistent :value='detailsDialog' transition="dialog-bottom-transition")
          BillMobileDetails(v-if='detailsDialog' :request='currentRequest' @close ='detailsDialog=false' :admin="transactiontype")
        v-dialog(persistent :value='showBillDialogSales'  max-width='600px'   transition="dialog-bottom-transition" style="z-index: 9999")
          div(style ='position:relative; height: 100%;')
            bill-preview-sales(@close='showBillDialogSales=false' :item="currentTransaction" :currentType = 'getCurrentType' )
        v-dialog(persistent :value='showBillDialogPurchases'  max-width='600px'   transition="dialog-bottom-transition")
          div(style ='position:relative; height: 100%;')
            bill-preview-purchases(@close='showBillDialogPurchases=false' :item="currentTransaction" :currentType = 'getCurrentType' )
        v-dialog(persistent :value='showBillDialogTransfers'  max-width='600px'   transition="dialog-bottom-transition")
          div(style ='position:relative; height: 100%;')
            bill-preview-transfers(@close='showBillDialogTransfers=false' :item="currentTransaction" :currentType = 'getCurrentType' )
        product-log-filter(:item="item")
        h2.text-right.pa-4 Total: {{ returnTotalProducts }}
        v-data-table.elevation-1(
          v-if="!isMobile"
          style='font-size: 10px;'
          dense
          :headers='headers',
          :items='transactions',

          :footer-props=`{
              showFirstLastPage: true,
                  firstIcon: 'mdi-arrow-collapse-left',
                  lastIcon: 'mdi-arrow-collapse-right',
                  prevIcon: 'mdi-minus',
                  nextIcon: 'mdi-plus'
                  }`,
          expand
          item-key="name"
          )
              template(v-slot:item="props")
                  tr(@click="showBill(props.item.bill, props.expanded)")
                      td.text-xs-left
                          .datatable-cell-wrapper {{ props.item.type | translate }}
                              a(href="#") # {{props.item.reference_number}}
                      td.text-xs-left(style="font-size: 9px")
                          .datatable-cell-wrapper  {{ props.item.time | moment("h:mm:ss a, dddd, MMMM Do YYYY") }}
                      td.text-xs-left.red--text(v-if="props.item.bill.isCanceled || !props.item.bill.items") Anulada
                      td.text-xs-left(v-else :style='getstatus(props.item.bill.items) === "completed" ? "color: green":"color: #fb8c00"') {{getstatus(props.item.bill.items) | translateStatus}}
                      td.text-xs-left
                          .datatable-cell-wrapper  {{getCurrentType === 'purchases' ? props.item.location_to.name : props.item.location_from.name  }}
                      td.text-xs-left
                          .datatable-cell-wrapper  {{props.item.amount}}
                      //- Inventario
                      td.text-xs-left.pa-0(v-if="getCurrentType === 'purchases'")
                          | {{props.item.qty || props.item.qty === 0 ? `${props.item.qty} &#8594 ${+props.item.qty + +props.item.amount}`:'N/A'}}
                      td.text-xs-left.pa-0(v-if="getCurrentType === 'sales'")
                          | {{props.item.qty || props.item.qty === 0 ? `${props.item.qty} &#8594 ${Math.abs(+props.item.amount - +props.item.qty)}`:'N/A'}}
                      td.text-xs-left(v-if="getCurrentType === 'sales'")
                          .datatable-cell-wrapper  {{props.item.purchase | numberFormat}}
                      td.text-xs-left(v-if="getCurrentType !== 'transfers'")
                          .datatable-cell-wrapper()   {{ props.item.price | numberFormat}}
                      td.text-xs-left(v-if="getCurrentType ==='sales'")
                          .datatable-cell-wrapper  {{ props.item.utility.toFixed(2)}} %
                      td.text-xs-left(v-if="getCurrentType !== 'transfers'")
                          .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                      td.text-xs-left(v-if="getCurrentType === 'transfers'")
                          .datatable-cell-wrapper {{ props.item.location_to.name }}
              v-alert(v-slot:no-results='', :value='true', color='error', icon='warning')
                  | Tu busqueda para "{{ search }}"  no encontro resultados.
        v-flex(v-else style="max-width: 700px").mx-auto.mt-3
          v-text-field(v-model='search' append-outer-icon='mdi-search', :label="$t('purchases.search')" placeholder="Buscar por referencia o establecimiento" single-line='', hide-details='')
          v-list(two-line="" v-if="filteredTransactions.length > 0")
            v-list-item-group
              template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                v-list-item(:key="item.reference_number").notification
                  template(v-slot:default="{ active, toggle }")
                    v-list-item-content(@click="openDetail(item)")
                      p.font-weight-bold # {{item.reference_number}}
                      p.mt-2.red--text(v-if="item.isCanceled") Anulada
                      p.mt-2(v-if="item.type === 'purchases'") {{item.bill.provider}}
                      p.mt-2 {{item.location_from ? item.location_from.name : ''}}
                      p.mt-2 {{ item.location_to ? item.location_to.name : ''}}
                      p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                      p(v-if="item.bill.isCanceled || !item.bill.items").red--text.text-caption Anulada
                      p.mt-2(v-else :style='getstatus(item.bill.items) === "completed" ? "color: green":"color: #fb8c00"') {{getstatus(item.bill.items) | translateStatus}}
                      // p.mt-2(v-if="item.type === 'purchases'" :style='item.status === "completed" ? "color: green !important":"color: #fb8c00"') {{item.status | translateStatus}}
                      p(v-if="item.type !=='transfers'").mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                  v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
              v-pagination.my-4(v-model="page" :length="pageNumber")
          template(v-else)
            NoResults(title="No tienes movimientos", description="Puedes ver tus movimientos en otro rango de fechas")
</template>

<script>
  import ProductLogFilter from '../filters/ProductLogFilter'
  import BillPreviewSales from '@/components/custom/preview/transactions/SalesBillPreview'
  import BillPreviewPurchases from '@/components/custom/preview/transactions/PurchasesBillPreview'
  import BillPreviewTransfers from '@/components/custom/preview/transactions/TransfersBillPreview'
  import BillMobileDetails from '@/views/marketplace/component/profile/RequestDetails'
  import moment from 'moment'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  })
  export default {
    name: 'ProductLog',
    components: {
      ProductLogFilter,
      BillPreviewSales,
      BillPreviewPurchases,
      BillPreviewTransfers,
      BillMobileDetails,
      NoResults: () => import('@/components/custom/NoResults'),
    },

    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },
      translate: function (name) {
        switch (name) {
          case 'sales':
            return 'Venta'

          case 'purchases':
            return 'Compra'

          case 'transfers':
            return 'Traslado'

          case 'store':
            return 'Tienda'

          case 'warehouse':
            return 'Bodega'
        }
      },
      extractProduct (items) {
        const vm = this
        return items.filter((el) => {
          for (let i = 0; i < items.length; i++) {
            if (el.items[i].name.includes(vm.currentItem.name)) {
              return true
            }
          }
        })
      },
      moment: function (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm a')
      },
      translateStatus (value) {
        if (value) {
          switch (value) {
            case 'pending':
              return 'Pendiente'
            case 'completed':
              return 'Completo'
          }
        } else {
          return 'N/A'
        }
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    props: {
      item: Object,
    },
    data () {
      return {
        transactiontype: '',
        currentRequest: '',
        detailsDialog: false,
        showBillDialogSales: false,
        showBillDialogPurchases: false,
        showBillDialogTransfers: false,
        currentTransaction: null,
        page: 1,
        search: '',
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      transactions () {
        const vm = this
        try {
          return vm.$store.getters['products/getProductLog'].reverse()
        } catch (err) {
          return vm.$store.getters['products/getProductLog']
        }
      },
      returnTotalProducts () {
        const vm = this
        let total = 0
        vm.transactions.forEach(element => {
          if (element.bill.isCanceled) {
            total += 0
          } else {
            total += element.amount
          }
        })
        console.log(total)
        return total
      },
      getCurrentType () {
        return this.$store.getters['products/getCurrentType']
      },
      headers () {
        return [
          {
            sortable: false,
            text: 'Tipo',
            value: 'type',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Fecha',
            value: 'time',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.status'),
            value: 'status',
            align: 'left',
          },
          {
            sortable: false,
            text: 'Lugar',
            value: 'location',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Cantidad',
            value: 'amount',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Inventario',
            value: 'qty',
            align: this.getCurrentType !== 'transfers' ? 'left' : ' d-none',
          },
          {
            sortable: true,
            text: 'P.Compra',
            value: 'purchase',
            align: this.getCurrentType === 'transfers' ? ' d-none' : 'left',
          },
          {
            sortable: true,
            text: 'P.venta',
            value: 'price',
            align: this.getCurrentType !== 'sales' ? ' d-none' : 'left',
          },
          {
            sortable: true,
            text: 'Utilidad',
            value: 'utility',
            align: this.getCurrentType !== 'sales' ? ' d-none' : 'left',
          },
          {
            sortable: true,
            text: this.getCurrentType !== 'transfers' ? 'Total' : 'Destino',
            value: this.getCurrentType !== 'transfers' ? 'total' : 'destiny',
            align: 'left',
          },
        ]
      },
      pageNumber () {
        if (this.isMobile) {
          return Math.ceil(this.filteredTransactions.length / 10)
        } else {
          return Math.ceil(this.transactions.length / 10)
        }
      },
      filteredTransactions () {
        return this.transactions.filter((transaction) => {
          console.log(transaction)
          if (transaction.type === 'sales') {
            return (transaction.location_from.name.toLowerCase().match(this.search.toLowerCase()) || transaction.reference_number.toString().includes(this.search))
          } else {
            return (transaction.location_to.name.toLowerCase().match(this.search.toLowerCase()) || transaction.reference_number.toString().includes(this.search))
          }
        })
      },
    },
    mounted () {
      // const vm = this

      // vm.$store.dispatch('products/loadItems','inventory').then(function(){
      //     vm.$store.dispatch('products/setCurrentItem', vm.item).then(function(){
      //         // vm.$store.dispatch('products/loadProductLog', ['sales','','']).then(function(){
      //         //     //success
      //         // }).catch(function(err){
      //         //     console.log(err)
      //         // })
      //     }).catch(function(err){
      //         console.log(err)
      //     })
      //
      // }).catch(function(err){
      //     console.log(err)
      // })
    },
    methods: {
      showBill (item, expanded) {
        if (this.getCurrentType === 'sales') {
          this.transactiontype = 'sale'
        } else if (this.getCurrentType === 'purchases') {
          this.transactiontype = 'purchase'
        } else if (this.getCurrentType === 'transfers') {
          this.transactiontype = 'transfer'
        }
        this.currentRequest = item
        this.detailsDialog = true
        this.currentTransaction = item
        expanded = !expanded
      },
      setDates () {
        const vm = this
        vm.$store.dispatch('products/loadProductLog', ['sales', '', '']).then(function () {
          // success
        }).catch(function (err) {
          console.log(err)
        })
      },
      openDetail (item) {
        // console.log(item)
      },
      getstatus (items) {
        // console.log(items)
        const found = items.find(element => element.status === 'pending')
        // console.log(found)
        if (found) {
          return 'pending'
        } else {
          return 'completed'
        }
      },
    },

  }
</script>

<style lang='scss' scoped>
.notification{
  display: flex;
  width: 95%;
  margin: 0 auto;
  // border-radius: 10px !important;
  box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
  &__container{
    @media (max-width: 1024px){
      background: transparent;
    }
  }
  &__date{
    font-size: 13px;
    color: #808184;
  }
  &__price{
    color: #35a3a9 !important;
  }
  &__description{
    color: #808184;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.2;
  }
}
</style>
